import { initializeApp, getApps, FirebaseApp } from 'firebase/app';
import { getAuth, Auth } from 'firebase/auth';
import { getFirestore, Firestore } from 'firebase/firestore';
import { getStorage, FirebaseStorage } from 'firebase/storage';
import { getFunctions, Functions } from 'firebase/functions';
import { getAnalytics, Analytics } from 'firebase/analytics';
import { getPerformance } from 'firebase/performance';

/**
 * Firebase configuration from environment variables
 */
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

/**
 * Initialize Firebase app (singleton pattern)
 */
const existingApps = getApps();
const app: FirebaseApp =
  existingApps.length === 0
    ? initializeApp(firebaseConfig)
    : (existingApps[0] as FirebaseApp);

/**
 * Firebase services
 */
export const auth: Auth = getAuth(app);
export const db: Firestore = getFirestore(app);
export const storage: FirebaseStorage = getStorage(app);
export const functions: Functions = getFunctions(app);

/**
 * Region-specific function instances for multi-region deployment
 */
export const functionsUsCentral1: Functions = getFunctions(app, 'us-central1');
export const functionsUsEast1: Functions = getFunctions(app, 'us-east1');
export const functionsUsWest1: Functions = getFunctions(app, 'us-west1');

/**
 * Analytics and Performance (only in browser, not SSR)
 */
export const analytics: Analytics | null =
  typeof window !== 'undefined' && import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
    ? getAnalytics(app)
    : null;

export const performance =
  typeof window !== 'undefined' ? getPerformance(app) : null;

export { app };

